import PropTypes from 'prop-types'

import styles from './PageError.css'
import { useSilentPage } from '../../context/silentPageContext'
import { unbindBeforeunload } from '../Proposal/Common/BeforeUnload'

const PageError = props => {
  unbindBeforeunload()

  const { isSilentPage, setSilentPageTo } = useSilentPage()
  if (!isSilentPage) { setSilentPageTo(true) }

  const {
    children,
    errorMessage,
    enableHomeLink = false,
    withImage = false,
    withErrorMessage = false
  } = props

  if (children) {
    if (!withErrorMessage) {
      return (
        <div className={styles.pageErrorWrap}>
          {children}
        </div>
      )
    }

    return (
      <div className={styles.pageErrorWrap}>
        {withImage && <div className={styles.contentImg} />}
        <div className={styles.contentMsg}>
          <div className={styles.contentTitle}>{errorMessage}</div>
          <div className={styles.contentSubTitle}>
            {children}
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className={styles.pageErrorWrap}>
      <div className={styles.contentImg} />
      <div className={styles.contentMsg}>
        <div className={styles.contentTitle}>{errorMessage}</div>
        {enableHomeLink && <div className={styles.contentSubTitle}><a href='/'>回首頁</a></div>}
      </div>
    </div>
  )
}

PageError.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object]),
  errorMessage: PropTypes.string
}

PageError.defaultProps = {
  children: null,
  errorMessage: '頁面錯誤'
}

export default PageError
